import React from 'react';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/bulkPurchase/priceTagStyles';
import { roundMoney } from 'utils/converters/roundMoney';
import { translate } from 'components/Translation';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IStorageSelectorProps {
	discount: number;
	price: number;
	currency: string;
}

const PriceTag = ({ discount, price, currency }: IStorageSelectorProps) => {
	const classes = useStyles();
	return (
		<>
			<div className={classes.mainWrapper}>
				<div className={classes.discountPriceWrapper}>
					<div className={classes.discountStrikethroughWrapper}>
						<div className={classes.miniDiscountPrice}>
							{translate('price', roundMoney(discount) || '')}
						</div>
					</div>
				</div>
				<div className={classes.priceTagWrapper}>
					<div className={classes.smallPrice}>{roundMoney(price)}</div>
					<div className={classes.additionalInfoWrapper}>
						<div className={classes.smallCurrencyWrapper}>{currency}</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default PriceTag;
